import { useIsAuthenticated, useMsal } from '@azure/msal-react';
import { InteractionStatus } from '@azure/msal-browser';
import { LandingPage } from '../pages/LandingPage';
import { NoAccess } from '../pages/NoAccess';

export function AuthGuard({
  children,
  redirectAccessDenied = false,
}: {
  children: React.ReactNode;
  /**
   * Bug #19757 — Entra redirected back refusing the user with AADSTS50105 (not assigned to the
   * application). Settled in main.tsx before render. There may be no account in the cache at all
   * in this case, so it is checked BEFORE the signed-out branch: showing the landing page's Sign
   * in button again would loop (click, be refused, come back to the button).
   */
  redirectAccessDenied?: boolean;
}) {
  const isAuthenticated = useIsAuthenticated();
  const { inProgress } = useMsal();

  // Mid-redirect (post loginRedirect, pre-token): show signing-in feedback.
  if (inProgress !== InteractionStatus.None) {
    return (
      <div className="flex h-screen items-center justify-center bg-gray-50">
        <div className="text-center">
          <div className="h-8 w-8 animate-spin rounded-full border-4 border-indigo-600 border-t-transparent mx-auto" />
          <p className="mt-4 text-sm text-gray-500">Signing in...</p>
        </div>
      </div>
    );
  }

  if (redirectAccessDenied) {
    return <NoAccess />;
  }

  // Pre-login: render the landing page with an explicit Sign In CTA.
  // (Replaces the previous auto-redirect — staff now click Sign In to authenticate.)
  if (!isAuthenticated) {
    return <LandingPage />;
  }

  return <>{children}</>;
}
